/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { delayedResponse, makeMockResponse } from '../mockUtils';
import { MainStatisticsDto } from './mainStatisticsClient.typings';
import { interval, Observable } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

const MAIN_STATISTICS_URL_RE = '1.0.0/dashboard/counters';

export function addMainStatisticsMockApi(mockAdapter: MockAdapter): void {
    const mainStatBackend = new MainStatisticsBackendStore({ updateDataEveryMs: 1200 });

    mockAdapter.onGet(MAIN_STATISTICS_URL_RE).reply((config) => {
        const data = mainStatBackend.getMainStat();

        return delayedResponse(makeMockResponse(200, data, config), 300);
    });
}

export class MainStatisticsBackendStore {
    private mainStat: MainStatisticsDto = {
        year: {
            cashBoxes: 4326,
            vatSum: 1451005295.43,
            docCount: 365117614,
            turnover: 10450022145.69,
        },
        today: {
            cashBoxes: 27579,
            vatSum: 235341961,
            docCount: 861,
            turnover: 16655447.39,
        },
    };

    constructor(options: { updateDataEveryMs: number }) {
        this.updateDataTask(options.updateDataEveryMs).subscribe();
    }

    private updateDataTask(updateDataEveryMs: number): Observable<null> {
        return interval(updateDataEveryMs).pipe(
            tap(() => {
                this.mainStat.year.cashBoxes = this.mainStat.year.cashBoxes + 1;
                this.mainStat.year.vatSum =
                    this.mainStat.year.vatSum + Math.round((Math.random() < 0.5 ? 1 : -0.5) * Math.random() * 500);
                this.mainStat.year.docCount = this.mainStat.year.docCount + Math.floor(Math.random() * 100) + 10;
                this.mainStat.year.turnover =
                    this.mainStat.year.turnover + Math.round((Math.random() < 0.5 ? 1 : -0.9) * Math.random() * 1500);

                this.mainStat.today.cashBoxes = this.mainStat.today.cashBoxes + Math.floor(Math.random() * 20) + 5;
                this.mainStat.today.vatSum =
                    this.mainStat.today.vatSum + Math.round((Math.random() < 0.5 ? 1 : -0.5) * Math.random() * 500);
                this.mainStat.today.docCount = this.mainStat.today.docCount + Math.floor(Math.random() * 100) + 10;
                this.mainStat.today.turnover =
                    this.mainStat.today.turnover + Math.round((Math.random() < 0.5 ? 1 : -0.9) * Math.random() * 1500);
            }),
            mapTo(null),
        );
    }

    public getMainStat() {
        return this.mainStat;
    }
}
